import Vue from "vue";
import Router from "vue-router";
import { store } from "../store/store";
import Swal from "sweetalert2";
// Containers
const TheContainer = () => import("@/containers/TheContainer");
import Dashboard from "@/views/Dashboard";
import Profile from "@/views/Profile";
import Referrals from "@/views/Referrals";
import ReferralStats from "@/views/ReferralStats";
import TerminalDevices from "@/views/terminal_managment/Devices";
import TerminalRequest from "@/views/terminal_managment/TerminalRequest";
import Terminals from "@/views/terminal_managment/AllTerminals";
import ViewTerminal from "@/views/terminal_managment/ViewTerminal";
import SystemSettings from "@/views/settings/SystemSettings";
import SavingReasons from "@/views/settings/SavingReasons";
import Balances from "@/views/settings/Balances";
import Collaterals from "@/views/settings/Collaterals";
import CustomerLevel from "@/views/settings/CustomerLevel";
import NanoLoanRates from "@/views/settings/NanoLoanRates";
import LoanOfficerSettings from "@/views/loans/LoanOfficerSettings";
import Roles from "@/views/settings/Roles";
import Payments from "@/views/payments/Payments";
import Payment from "@/views/payments/Payment";
import Cards from "@/views/cards/Cards";
import SMSList from "@/views/SMS/SMSList";
import SingleCard from "@/views/cards/SingleCard";
import CbaReports from "@/views/reports/CbaReports";

// views plans
import TargetPlan from "@/views/plans/Target";
import SingleTargetPlan from "@/views/plans/SingleTarget";
import AutoSavePlan from "@/views/plans/AutoSave";
import SingleAutoSavePlan from "@/views/plans/SingleAutoSave";
import PropertyPlan from "@/views/plans/Property";
import SinglePropertyPlan from "@/views/plans/SingleProperty";

// Views -> Auth
import Login from "@/views/auth/Login";
import ForgotPassword from "@/views/auth/ForgotPassword";
import Register from "@/views/auth/Register";

// Services
import Services from "@/views/services/Services";
import ServiceComponent from "@/views/services/ServiceComponent";

// banks
import Banks from "@/views/banks/Banks";
import Utility from "@/views/Utility";
import SendSMS from "@/views/SendSMS";

// Customers
import Customers from "@/views/customers/Customers";
import CustomerComponent from "@/views/customers/CustomerComponent";
import CreateCustomer from "@/views/customers/CreateCustomer";
import CustomerBehaviorDashboard from "@/views/customers/CustomerBehaviorDashboard";
import TransferHolds from "@/views/customers/TransferHolds";
import PushNotification from "@/views/PushNotification";
import Referral from "@/views/Referral";

//instant loans ssssa
import Loans from "@/views/loans/Loans";
import CompletedLoans from "@/views/loans/CompletedLoans";
import CollectionHistory from "@/views/loans/CollectionHistory";
import RefusedLoans from "@/views/loans/RefusedLoans";
import LoanWaivers from "@/views/loans/LoanWaivers";
import LoanAnalysis from "@/views/loans/LoanAnalysis";
import LoanComponent from "@/views/loans/LoanComponent";
import LoanOverview from "@/views/loans/LoanOverview";
import NanoLoanDashboard from "@/views/loans/NanoLoanDashboard";
import SweptLoans from "@/views/loans/SweptLoans";
import CreateLoan from "@/views/loans/CreateLoan";

//others loans
import OtherLoans from "@/views/other_loans/OtherLoans";
import ViewOtherLoanDetail from "@/views/other_loans/ViewOtherLoanDetail";



import Products from "@/views/products/Products";
import ProductComponent from "@/views/products/ProductComponent";
import Plans from "@/views/Plans";
import Staffs from "@/views/user_management/Staffs";
import Logs from "@/views/user_management/Logs";
import AdminTracks from "@/views/user_management/AdminTracks";
import Staff from "@/views/user_management/Staff";
import ChargesSettings from "@/views/settings/ChargesSettings";
import GLAccount from "@/views/settings/GLAccount";
import OnboardCustomer from "@/views/Onboard/OnboardCustomer";
import SingleOnboard from "@/views/Onboard/SingleOnboard";
import Promos from "@/views/promo/Promos";
import Ads from "@/views/ads/Ads";
import Promo from "@/views/promo/Promo";
import Tickets from "@/views/support/Tickets";
import Ticket from "@/views/support/Ticket";
import AccountDeletionRequests from "@/views/support/AccountDeletionRequests";
import { UserService } from "../services/user.service";
import ApiService from "../services/api.service";
import ActiveOtherLoans from "../views/other_loans/ActiveOtherLoans.vue";
import AccountRequests from "../views/customers/AccountRequests.vue";
import KiddiesAccount from "../views/customers/KiddiesAccount.vue";
import ViewKiddiesAccount from "../views/customers/ViewKiddiesAccount.vue";
Vue.use(Router);

// note it is only export default new router
// export default new Router({
const router = new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    // {
    //   path: "/login",
    //   name: "Login",
    //   component: Login,
    //   meta: {
    //     requiresGuest: true

    //   }
    // },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {}
    },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {}
    },
    {
      path: "/",
      component: TheContainer,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "utility",
          name: "Utility",
          component: Utility,
          meta: {
            permission_slug: "utility"
          }
        },
        {
          path: "tickets",
          name: "Tickets",
          component: Tickets,
          meta: {
            permission_slug: "tickets"
          }
        },
        {
          path: "ticket/:slug",
          name: "Ticket",
          component: Ticket,
          props: true,
          meta: {
            permission_slug: "tickets"
          }
        },
        {
          path: "account-deletion-requests",
          name: "AccountDeletionRequests",
          component: AccountDeletionRequests,
          meta: {
            permission_slug: "account-deletion-requests"
          }
        },
        {
          path: "promos",
          name: "Promos",
          component: Promos,
          meta: {
            permission_slug: "promos"
          }
        },
        {
          path: "ads",
          name: "Ads",
          component: Ads,
          meta: {
            permission_slug: "promos"
          }
        },
        {
          path: "promo/:slug",
          name: "Promo",
          props: true,
          component: Promo,
          meta: {
            permission_slug: "view-promo"
          }
        },
        {
          path: "referrals/:slug",
          name: "Referrals",
          props: true,
          component: Referrals,
          meta: {
            permission_slug: "referrals"
          }
        },
        {
          path: "referral-stats",
          name: "ReferralStats",
          component: ReferralStats,
          meta: {
            permission_slug: "referrals"
          }
        },
        {
          path: "onboard-customer",
          name: "OnboardCustomer",
          component: OnboardCustomer,
          meta: {
            permission_slug: "onboard-customer"
          }
        },
        {
          path: "onboard-customer/:slug",
          name: "SingleOnboard",
          component: SingleOnboard,
          props: true,
          meta: {
            permission_slug: "onboard-customer"
          }
        },
        {
          path: "profile",
          name: "Profile",
          component: Profile,
          meta: {
            permission_slug: "index"
          }
        },
        // {
        //   path: "plans",
        //   name: "Plans",
        //   component: Plans,
        //   meta: {
        //     permission_slug: "dashboard"
        //   }
        // },
        {
          path: "cards",
          name: "Cards",
          component: Cards,
          meta: {
            permission_slug: "card-request"
          }
        },
        {
          path: "cards/:slug",
          name: "SingleCard",
          props: true,
          component: SingleCard,
          meta: {
            permission_slug: "view-card"
          }
        },
        {
          path: "kiddies_accounts",
          name: "KiddiesAccount",
          component: KiddiesAccount,
          meta: {
            permission_slug: "card-request"
          }
        },
        {
          path: "kiddies_accounts/:slug",
          name: "ViewKiddiesAccount",
          props: true,
          component: ViewKiddiesAccount,
          meta: {
            permission_slug: "view-card"
          }
        },
        {
          path: "kiddies/:reference",
          name: "ViewKiddiesAccountByReference",
          props: true,
          component: ViewKiddiesAccount,
          meta: {
            permission_slug: "view-card"
          }
        },
        {
          path: "loans",
          name: "Loans",
          component: Loans,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "OtherLoans",
          name: "OtherLoans",
          component: OtherLoans,
          meta: {
            permission_slug: "other-loans"
          }
        },
        {
          path: "ActiveOtherLoans",
          name: "ActiveOtherLoans",
          component: ActiveOtherLoans,
          meta: {
            permission_slug: "other-loans"
          }
        },
        {
          path: "view-other-loan/:slug",
          name: "ViewOtherLoanDetail",
          component: ViewOtherLoanDetail,
          props: true,
          meta: {
            permission_slug: "view-other-loan"
          }
        },
        {
          path: "completed-loans",
          name: "CompletedLoans",
          component: CompletedLoans,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "collection-history",
          name: "CollectionHistory",
          component: CollectionHistory,
          meta: {
            permission_slug: "collection-history"
          }
        },
        {
          path: "refeused-loans",
          name: "RefusedLoans",
          component: RefusedLoans,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "loan-analysis",
          name: "LoanAnalysis",
          component: LoanAnalysis,
          meta: {
            permission_slug: "loan-analysis"
          }
        },
        {
          path: "loan-overview",
          name: "LoanOverview",
          component: LoanOverview,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "nano-loan-dashboard",
          name: "NanoLoanDashboard",
          component: NanoLoanDashboard,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "swept-loans",
          name: "SweptLoans",
          component: SweptLoans,
          meta: {
            permission_slug: "instant-loans"
          }
        },
        {
          path: "loan-waivers",
          name: "LoanWaivers",
          component: LoanWaivers,
          meta: {
            permission_slug: "instant-loan-wavier"
          }
        },
        {
          path: "loans/:slug",
          name: "LoanComponent",
          component: LoanComponent,
          props: true,
          meta: {
            permission_slug: "view-instant-loan"
          }
        },
        {
          path: "create-loan",
          name: "CreateLoan",
          component: CreateLoan,
          meta: {
            permission_slug: "create-instant-loan"
          }
        },
        // {
        //   path: "products",
        //   name: "Products",
        //   component: Products,
        //   meta: {
        //     permission_slug: "dashboard"
        //   }
        // },
        // {
        //   path: "products/:slug",
        //   name: "ProductComponent",
        //   component: ProductComponent,
        //   props: true,
        //   meta: {
        //     permission_slug: "dashboard"
        //   }
        // },
        {
          path: "logs",
          name: "Logs",
          component: Logs,
          meta: {
            permission_slug: "audit-logs"
          }
        },
        {
          path: "AdminTracks",
          name: "AdminTracks",
          component: AdminTracks,
          meta: {
            permission_slug: "admin-tracks"
          }
        },
        {
          path: "staffs",
          name: "Staffs",
          component: Staffs,
          meta: {
            permission_slug: "staffs"
          }
        },
        {
          path: "staff/:slug",
          name: "Staff",
          component: Staff,
          props: true,
          meta: {
            permission_slug: "view-staff"
          }
        },
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            permission_slug: "dashboard"
          }
        },
        {
          path: "sendsms",
          name: "SendSMS",
          component: SendSMS,
          meta: {
            permission_slug: "send-sms"
          }
        },
        {
          path: "smslist",
          name: "SMSList",
          component: SMSList,
          meta: {
            permission_slug: "sms-list"
          }
        },
        {
          path: "banks",
          name: "Banks",
          component: Banks,
          meta: {
            permission_slug: "create-update-bank"
          }
        },
        {
          path: "services",
          name: "Services",
          component: Services,
          meta: {
            permission_slug: "services"
          }
        },
        {
          path: "services/:slug",
          name: "ServiceComponent",
          component: ServiceComponent,
          props: true,
          meta: {
            permission_slug: "view-service"
          }
        },
        {
          path: "customers",
          name: "Customers",
          component: Customers,
          meta: {
            permission_slug: "customers"
          }
        },
        {
          path: "customer-behavior",
          name: "CustomerBehaviorDashboard",
          component: CustomerBehaviorDashboard,
          meta: {
            permission_slug: "dashboard"
          }
        },
        {
          path: "customers/account-requests",
          name: "AccountRequestComponent",
          component: AccountRequests,
          meta: {
            permission_slug: "customers"
          }
        },
        {
          path: "transfer-holds",
          name: "TransferHolds",
          component: TransferHolds,
          meta: {
            permission_slug: "view-transfer-holds"
          }
        },
        {
          path: "create-customer",
          name: "CreateCustomer",
          component: CreateCustomer,
          meta: {
            permission_slug: "onboard-customer"
          }
        },
        {
          path: "customers/:slug",
          name: "CustomerComponent",
          component: CustomerComponent,
          props: true,
          meta: {
            permission_slug: "view-customer"
          }
        },
        {
          path: "/transactions",
          name: "Payments",
          component: Payments,
          meta: {
            permission_slug: "payments"
          }
        },
        {
          path: "/transactions/:slug",
          name: "Payment",
          component: Payment,
          props: true,
          meta: {
            permission_slug: "view-payment"
          }
        },

        {
          path: "terminal-management/devices",
          name: "TerminalDevices",
          component: TerminalDevices,
          meta: {
            permission_slug: "devices"
          }
        },
        {
          path: "terminal-management/terminal-request",
          name: "TerminalRequest",
          component: TerminalRequest,
          meta: {
            permission_slug: "terminal-request"
          }
        },
        {
          path: "terminal-management/terminals",
          name: "Terminals",
          component: Terminals,
          meta: {
            permission_slug: "terminals"
          }
        },
        {
          path: "terminal-management/terminal/:slug",
          props: true,
          name: "ViewTerminal",
          component: ViewTerminal,
          meta: {
            permission_slug: "view-terminal"
          }
        },
        {
          path: "settings/system-settings",
          name: "SystemSettings",
          component: SystemSettings,
          meta: {
            permission_slug: "system-settings"
          }
        },
        {
          path: "settings/balances",
          name: "Balances",
          component: Balances,
          meta: {
            permission_slug: "provider-balance"
          }
        },
        {
          path: "reports/cba-reports",
          name: "CbaReports",
          component: CbaReports,
          meta: {
            permission_slug: "cba-reports"
          }
        },
        {
          path: "settings/charges-settings",
          name: "ChargesSettings",
          component: ChargesSettings,
          meta: {
            permission_slug: "transfer-charges"
          }
        },
        {
          path: "settings/gl-accounts",
          name: "GLAccount",
          component: GLAccount,
          meta: {
            permission_slug: "gls"
          }
        },
        // {
        //   path: "settings/saving-reasons",
        //   name: "SavingReasons",
        //   component: SavingReasons,
        //   meta: {
        //     permission_slug: "savings-category"
        //   }
        // },
        // {
        //   path: "settings/collaterals",
        //   name: "Collaterals",
        //   component: Collaterals,
        //   meta: {
        //     permission_slug: "savings-category"
        //   }
        // },
        // {
        //   path: "settings/ads",
        //   name: "Ads",
        //   component: Ads,
        //   meta: {
        //     permission_slug: "ads"
        //   }
        // },
        {
          path: "settings/roles",
          name: "Roles",
          component: Roles,
          meta: {
            permission_slug: "roles"
          }
        },
        {
          path: "settings/customer-level",
          name: "CustomerLevel",
          component: CustomerLevel,
          meta: {
            permission_slug: "kyc-levels"
          }
        },
        {
          path: "settings/nano-loan-rates",
          name: "NanoLoanRates",
          component: NanoLoanRates,
          meta: {
            permission_slug: "nano-loan-rates"
          }
        },
        {
          path: "loans/officer-settings",
          name: "LoanOfficerSettings",
          component: LoanOfficerSettings,
          meta: {
            permission_slug: "manage-loan-officer-settings"
          }
        },
        {
          path: "push-notification",
          name: "PushNotification",
          component: PushNotification,
          meta: {
            permission_slug: "push-notification"
          }
        }
        // {
        //   path: "referral",
        //   name: "Referral",
        //   component: Referral,
        //   meta: {
        //     permission_slug: "settings"
        //   }
        // }
      ]
    }
  ],
  mode: "history"
});

function mustChangePassword() {
  const user = store.getters.userObj || {};
  return user.must_change_password === true || user.must_change_password === 1;
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      //redirect to login page
      next("/");
    } else {
      let permissions = store.getters.permissions;

      if (!permissions || (Array.isArray(permissions) && !permissions.length)) {
        try {
          ApiService.setHeader();
          const response = await ApiService.get("auth/user");
          const userData = response.data && response.data.data ? response.data.data : {};
          if (userData.user) {
            store.commit("setUser", userData.user);
          }
          store.commit("setPermissions", userData.permissions || []);
          permissions = store.getters.permissions;
        } catch (e) {
          Swal.fire({
            title: "Error!",
            text: "You're not authorized for this page",
            icon: "error"
          });
          UserService.logout();
          store.commit("logoutRequest");
          return next("/");
        }
      }

      if (!permissions) {
        Swal.fire({
          title: "Error!",
          text: "You're not authorized for this page",
          icon: "error"
        });
        UserService.logout();
        store.commit("logoutRequest");
        return next("/");
      }

      if (mustChangePassword() && to.name !== "Profile") {
        return next({ name: "Profile" });
      }

      if (
        permissions.includes(to.meta.permission_slug) ||
        to.meta.permission_slug === "index"
      ) {
        return next();
      }

      Swal.fire({
        title: "Error!",
        text: "You're not authorized for this page",
        icon: "error"
      });
      UserService.logout();
      store.commit("logoutRequest");
      return next("/");
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (store.getters.loggedIn) {
      next(mustChangePassword() ? "/profile" : "/dashboard");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
